export default __webpack_public_path__ + "static/media/jntua-location.d09853c8.png";